if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      const activeSubmitButton = evt.submitter || this.submitButton;
      if (
        activeSubmitButton.disabled ||
        activeSubmitButton.hasAttribute('aria-disabled')
      ) return;

      this.handleErrorMessage();
      this.error = false;
      this.keepSubmitDisabled = false;
      this.addedSuccessfully = false;
      this.lastErrorMessage = '';

      const submitButtons = this.getSubmitButtons(activeSubmitButton);
      submitButtons.forEach((button) => {
        button.setAttribute('aria-disabled', true);
        button.classList.add('loading');
        button.querySelector('.loading-overlay__spinner')?.classList.remove('hidden');
      });

      var config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      var formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }

      this.formIdInputValue = this.form.querySelector('[name=id]').value;
      if (this.formIdInputValue.includes(',')) {
          formData.delete('id');
          formData.delete('quantity');
      } 
      
      config.body = formData;

      this.skipCart = false;
      if (this.form.querySelector('[name=id]').dataset.skipCart && this.form.querySelector('[name=id]').dataset.skipCart === 'true') {
        this.skipCart = true;
      }

      const enqueueMutation = window.stocktechEnqueueCartMutation || ((task) => task());
      enqueueMutation(() => fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.lastErrorMessage = response.description || window.cartStrings?.error || 'Unable to update the cart.';
            this.handleErrorMessage(this.lastErrorMessage);
            this.error = true;
            return;
          } else if (this.skipCart) {
            window.location = "/checkout";
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          this.addedSuccessfully = true;
          if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form'});
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        }))
        .catch((e) => {
          console.error(e);
          this.error = true;
          this.lastErrorMessage = window.cartStrings?.error || 'Unable to update the cart.';
          this.handleErrorMessage(this.lastErrorMessage);
        })
        .finally(() => {
          submitButtons.forEach((button) => {
            button.classList.remove('loading');
            if (!this.keepSubmitDisabled) button.removeAttribute('aria-disabled');
            button.querySelector('.loading-overlay__spinner')?.classList.add('hidden');
          });
          if (this.addedSuccessfully && this.cart?.classList.contains('is-empty')) {
            this.cart.classList.remove('is-empty');
          }
          this.form.dispatchEvent(new CustomEvent('product-form:complete', {
            bubbles: true,
            detail: { message: this.lastErrorMessage, blocked: this.keepSubmitDisabled }
          }));
        });
    }

    getSubmitButtons(activeSubmitButton) {
      const associatedButtons = Array.from(
        document.querySelectorAll('button[name="add"][form]')
      ).filter((button) => button.getAttribute('form') === this.form.id);

      return Array.from(new Set([
        this.submitButton,
        activeSubmitButton,
        ...associatedButtons
      ].filter(Boolean)));
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
